/** Pusher event carrying a "refetch now" signal for missions progress. */
export const MISSION_PROGRESS_EVENT = 'mission_progress';

/**
 * Endpoint key checked against the `CONFIG_PUSHER_ENABLED_ENDPOINTS` Split config
 * (via `usePusherEnabledForEndpoint`). Must be added to that flag's config array to
 * enable the real-time subscription per environment.
 */
export const MISSIONS_PUSHER_ENDPOINT = 'gamification-missions';

/**
 * Per-user gamification channel name. `userId` is the platform user id (`user.id` /
 * the JWT `id` claim), NOT the legacy `sub` claim. It MUST be lower-cased — the server
 * signs only this exact form, so a mis-cased name is rejected.
 */
export const getMissionsChannelName = (userId: string): string =>
  `private-gamification-user-${userId.toLowerCase()}`;

/** Payload for the `mission_progress` event (no mission fields — REST is source of truth). */
export interface MissionProgressPayload {
  id: string;
  rev?: number;
}
